<div class="container-fluid py-4">
  <div class="py-4">
    <div class="d-inline-block align-middle me-3"><img src="assets/icons/icon-donate.svg" alt="" /></div>
    <h1 class="d-inline-block align-middle m-0">{{ 'DONATE_HINT' | translate }}</h1>
  </div>
  <p class="h4 mb-4">{{ 'SUPPORT_PAYPAL_SERVICE' | translate }}</p>
  <button class="btn btn-primary donate-button" (click)="donate()" type="button">
    {{ 'I_WANT_TO_DONATE' | translate }}
  </button>
  <p class="h4 mb-4">{{ 'DONATE_BY_QR' | translate }}</p>
  <app-qr-code [qrCodeUrl]="paypalDonateUrl"></app-qr-code>
</div>
